module.exports = __webpack_public_path__ + "img/Smart-Art-Unternehmen.0a257e88.png";